import { Box, Drawer, DrawerProps, Grid } from "@mui/material"
import { AdjudicationDecision, AdjudicatorTypeOfAttack, IAdjudicatorDecisionFilter } from "../../../../Store/Adjudication/types"
import { BoxButton } from "../BoxButton"
import ButtonGradient from "../ButtonGradient"
import ButtonLightGray from "../ButtonLightGray"
import FilterDrawerMoreTextField from "../FilterDrawerMoreTextField"
import FilterDrawerTitle from "../FilterDrawerTitle"
import FilterTimeRange from "../FilterTimeRange"
import { GridButtons } from "../grid/GridButtons"
import SelectCheckmarks from "../SelectCheckmarks"

interface IAdjudicationDecisionSolvedDrawerMoreFilterProps extends DrawerProps {
    onFilterApply: (filter: IAdjudicatorDecisionFilter) => void,
    resetFilter: () => void,
    filter: IAdjudicatorDecisionFilter,
    setFilter: React.Dispatch<React.SetStateAction<IAdjudicatorDecisionFilter>>
}

const AdjudicationDecisionSolvedDrawerMoreFilter: React.FC<IAdjudicationDecisionSolvedDrawerMoreFilterProps> = (props) => {

    const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
        if (event.key === 'Enter') {
            props.onFilterApply(props.filter)
        }
    }

    const handleOnClick = () => {
        props.resetFilter();
    }

    return (
        <Drawer
            anchor={props.anchor}
            open={props.open}
            onClose={props.onClose}
            style={{position: "relative"}}
            onKeyDown={(e) => handleKeyDown(e)}
        >
            <Box style={{maxWidth: "450px"}}>
                <Grid container>
                    <Grid item xs={8} style={{paddingBottom: 0}}>
                        <FilterDrawerTitle>
                            More Filters
                        </FilterDrawerTitle>
                    </Grid>
                </Grid>
                <Grid container style={{paddingLeft: "1rem", paddingRight: "1rem"}}>
                    <FilterTimeRange
                        lowerBound={props.filter.dateLowerBound}
                        upperBound={props.filter.dateUpperBound}
                        setLowerBound={(value) => props.setFilter((prev: any) => {return {...prev, dateLowerBound: value}})}
                        setUpperBound={(value) => props.setFilter((prev: any) => {return {...prev, dateUpperBound: value}})}
                    />
                    <FilterDrawerMoreTextField
                        title="UUID"
                        value={props.filter.uuid}
                        setValue={(value) => {props.setFilter({...props.filter, uuid: value})}}
                    />
                    <FilterDrawerMoreTextField
                        title="Adjudication UUID"
                        value={props.filter.adjudicationUuid}
                        setValue={(value) => {props.setFilter({...props.filter, adjudicationUuid: value})}}
                    />
                    <SelectCheckmarks
                        title="Decision"
                        value={props.filter.decision}
                        setValue={(value) => props.setFilter({...props.filter, decision: value})}
                        type={AdjudicationDecision}
                        prefix="Decision"
                    />
                    <SelectCheckmarks
                        title="Type of attack"
                        value={props.filter.attack}
                        setValue={(value) => props.setFilter({...props.filter, attack: value})}
                        type={AdjudicatorTypeOfAttack}
                        prefix="Attack"
                    />
                </Grid>
                <Box style={{marginBottom: "2rem"}} />
            </Box>
            <GridButtons container style={{position: "absolute"}}>
                <Grid item xs={6} >
                    <BoxButton>
                        <ButtonLightGray
                            onClick={handleOnClick}
                            variant='text'
                            color="primary"
                            style={{height: "100%", width: "100%"}}
                        >
                            Clear filter
                        </ButtonLightGray>
                    </BoxButton>
                </Grid>
                <Grid item xs={6}>
                    <BoxButton>    
                        <ButtonGradient
                            onClick={() => props.onFilterApply(props.filter)}
                            variant='contained'
                            color="primary"
                            style={{height: "100%", width: "100%"}}
                        >
                            Apply
                        </ButtonGradient>
                    </BoxButton>
                </Grid>
            </GridButtons>
        </Drawer>
    )
}

export default AdjudicationDecisionSolvedDrawerMoreFilter